import React, { useEffect, useState } from "react";
import { ExchangeRate } from "../../pages";
import { ExchangeController } from "../../controllers";
import { toJS } from "mobx";
import { exchangeStore } from "../../stores";

const ExchangeRateContainer = () => {
    const [loading, setLoading] = useState(false);
    const [rateModal, setRateModal] = useState(false);

    useEffect(() => {
        const fetchRate = async () => {
            setLoading(true);
            await Promise.all([
                ExchangeController.getExchangeRate(),
            ])
            setLoading(false);
        }
        fetchRate()
    }, [])

    const goToRateModal = () => {
        setRateModal(true);
    }

    const closeModal = () => {
        setRateModal(false);
    }
    return (
        <ExchangeRate
            loading={loading}
            rateModal={rateModal}
            goToRateModal={goToRateModal}
            closeModal={closeModal}
            exchangeRates={toJS(exchangeStore.exchangeRate)}
        />
    )
}

export default ExchangeRateContainer